import { SET_APP_MACHINE_ID, SET_DEVICE_CONFIGURATION } from '@/store/mutation-types'

export default {
  [SET_DEVICE_CONFIGURATION] (state, { configuration }) {
    state.configuration = configuration
  },
  [SET_APP_MACHINE_ID] (state, { machineId }) {
    state.appMachineId = machineId
  }
}
